<!--升级任务列表-->
<template>
  <div class="firmware-list">
    <div class="header">
      <div class="title"></div>
      <el-button
        :disabled="rolesCode === 'SALE'"
        type="add"
        size="14"
        icon="el-icon-plus"
        @click="dialogVisible = true">新建升级任务</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F5F6F7' }" size="medium">
      <el-table-column prop="name" label="任务名称"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column :formatter="statusFormatter" label="状态"></el-table-column>
      <el-table-column fixed="right" label="操作" width="270">
        <template slot-scope="scope">
          <el-button type="text" size="operate" @click="handleDetails(scope.row)">详情</el-button>
          <el-button
            v-if="scope.row.state == 0"
            type="text"
            size="operate"
            :disabled="rolesCode === 'SALE'"
            @click="terminateUpgradeTaskFun(scope.row)">终止</el-button>
          <el-button
            v-if="scope.row.state == 2"
            type="text"
            size="operate"
            :disabled="rolesCode === 'SALE'"
            @click="deleteUpgradeTaskFun(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="current"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>

    <el-dialog
      v-loading="uploadLoading"
      title="新建升级任务"
      :visible.sync="dialogVisible"
      width="830px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      custom-class="upgrade-task-dialog">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="任务名称" prop="name">
              <template #label>
                <span>任务名称</span>&nbsp;
                <el-tooltip content="支持中英文和数字,长度2-32,名称不可重复" placement="bottom">
                  <i class="iconfont icon-wenhao"></i>
                </el-tooltip>
              </template>
              <el-input v-model="form.name" maxlength="32" placeholder="请输入任务名称">
              </el-input>
            </el-form-item>
            <el-form-item label="升级方案" prop="otaMode">
              <el-radio-group v-model="form.otaMode" @change="handleOtaModeChange">
                <el-radio v-for="item in otaModeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="升级版本号" prop="upgradeVersion">
              <el-input
                v-model="form.upgradeVersion"
                minlength="1"
                :disabled="true"
                show-word-limit
                placeholder="当前版本号"></el-input>
            </el-form-item>

            <el-form-item label="可升级版本号（可多选）" prop="upgradeableVersionList">
              <!-- <el-select
                v-model="form.upgradeableVersionList"
                multiple
                placeholder="请选择升级版本号"
                clearable
                @change="downgradeVersionChange">
                <el-option
                  v-for="item in upgradeableFirmwareIdOptions"
                  :key="item.id"
                  :label="item.version"
                  :value="item.version">
                </el-option>
              </el-select> -->
              <el-table
                ref="versionTable"
                :data="upgradeableFirmwareIdOptions"
                style="width: 60%"
                size="medium"
                :header-cell-style="{ background: '#F5F6F7' }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="100">
                </el-table-column>
                <el-table-column prop="version" label="版本号" />
              </el-table>
            </el-form-item>
            <!-- 升级方案为 静默升级的时候，需要选择任务有效截止时间，默认任务有效截止时间为1天 -->
            <!-- 只有1~7天的选项，默认1天 -->
            <el-form-item v-if="form.otaMode === 'SOTA'" label="有效截止时间" prop="taskExpireTime">
              <el-select v-model="form.taskExpireTime" style="width: 30%">
                <el-option v-for="item in taskExpireTimeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="升级范围" prop="upgradeRange">
              <el-radio-group v-model="form.upgradeRange" @change="handleUpgradeRangeChange">
                <el-radio :label="0">全部设备</el-radio>
                <el-radio :label="1">特定设备</el-radio>
                <!-- 先注释 特定标签 类型的，目前还没使用/还没实现 -->
                <!-- <el-radio :label="2">特定标签</el-radio> -->
                <el-radio :label="3">特定项目</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 1: 特定设备 -->
            <div v-if="form.upgradeRange == 1">
              <el-form-item label="" prop="deviceIdList">
                <!-- 特定设备: 设备ID输入框 -->
                <el-input
                  v-model="form.deviceIdList"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入设备ID,多个设备ID之间以英文“ ; ”分隔"
                  @input="onSpecificDeviceIdInput" />

                <!-- 特定设备的结果：检查升级设备ID -->
                <specificDeviceDialog
                  ref="specificDevice"
                  :device-id-list="form.deviceIdList"
                  :product-id="productId"
                  @update-deviceIdList="updateDeviceIdList"
                />
              </el-form-item>
              <div class="button-container__right">
                <el-button size="mini" type="primary" :disabled="!form.deviceIdList" @click="handleOpenResultForSpecificDevice">确定</el-button>
              </div>
            </div>
            <!-- 先注释 特定标签 类型的，目前还没使用/还没实现 -->
            <!-- <el-form-item v-if="form.upgradeRange == 2" label="" prop="deviceTagId"> -->
            <!-- <el-select v-model="form.deviceTagId" placeholder="请选择标签"> -->
            <!-- <el-option -->
            <!-- v-for="item in labelsList" -->
            <!-- :key="item.id" -->
            <!-- :label="item.tagName" -->
            <!-- :value="item.id"> -->
            <!-- </el-option> -->
            <!-- </el-select> -->
            <!-- </el-form-item> -->

            <!-- 3: 特定项目 specificProjectDetailsShowControl -->
            <div v-if="form.upgradeRange == 3">
              <el-form-item label="" prop="deviceIdList" class="project-device-form-item">
                <specificProjectDeviceList
                  ref="specificProject"
                  class="specific-project-device-list"
                  :product-id="productId"
                  @update-deviceIdList="updateDeviceIdList"
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 设备ID冲突提示弹窗 -->
      <conflictDetailsDialog ref="conflictDetails" @confirm="onConfirm" />

      <!-- 提交按钮组 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="14" @click="handleClose()">取 消</el-button>
        <el-button type="primary" size="14" :disabled="!canSaveUpgradeTask" @click="submitForm('form')">保存</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-drawer title="升级任务详情" :visible.sync="drawer" :direction="direction" size="720px">
      <template #title>
        <div class="custom-header">
          <span>升级任务详情</span>
          <span class="left width-60">版本号：</span><span class="right">{{ taskInfo.upgradeVersion }}</span>
          <div class="status">
            <div class="status-icon"></div>
            <div>{{ taskInfo.state }}</div>
          </div>
        </div>
      </template>
      <div v-loading="taskLoading">
        <div class="taskInfo">
          <div class="InfoTitle">任务基本信息
            <el-button
              type="add"
              size="mini"
              icon="el-icon-refresh-right"
              class="refresh"
              @click="handleDetails">刷新</el-button> </div>
          <div class="martop-16"><span class="left">任务名称</span><span class="right">{{ taskInfo.name }}</span></div>
          <div class="martop-16"><span class="left">升级方案</span><span class="right">{{ getOtaName(taskInfo.otaMode) }}</span></div>
          <div class="martop-16"><span class="left">升级版本号</span><span class="right">{{ form.upgradeVersion }}</span></div>
          <div class="martop-16"><span class="left">可升级版本号</span><span class="right">{{ taskInfo.upgradeableVersionList
          }}</span> </div>
          <div v-if="taskInfo.otaMode === 'SOTA'" class="martop-16"><span class="left">有效截止时间</span><span class="right">{{ taskInfo.taskExpireTime || '-' }}</span></div>
        </div>
        <div class="taskInfo">
          <div class="InfoTitle">任务执行结果</div>
          <div class="martop-16"><span class="left">可升级设备数</span><span class="right">{{ taskInfo.deviceTotalNumber
          }}</span></div>
          <div class="martop-16"><span class="left">升级成功设备数</span><span class="right">{{ taskInfo.deviceSuccessNumber
          }}</span></div>
          <div class="martop-16"><span class="left">升级失败设备数</span><span class="right">{{ taskInfo.deviceFailureNumber
          }}</span></div>
          <div class="martop-16"><span class="left">未升级设备数</span><span class="right">{{
            taskInfo.deviceNotStartNumber }}</span></div>
          <div class="martop-16"><span class="left">离线排队设备数</span><span class="right">{{
            taskInfo.offLineNumber }}</span></div>
          <a :href="dynamicLink" rel="opener" target="_blank">
            <el-button
              type="add"
              size="mini"
              class="refresh">查看ota任务具体数据</el-button>
          </a>
        </div>
      </div>

    </el-drawer>
  </div>
</template>
<script>
import {
  addUpgradeTask,
  deleteUpgradeTask,
  getUpgradeTaskInfo,
  getUpgradeTaskList,
  getUpgradeVersionList,
  postDeviceUpgradeConflict,
  terminateUpgradeTask
} from "@/api/product/product-details"
// import { getList } from '@/api/device-identity-auth/equipment-labels'
import { mapGetters } from 'vuex'
import specificDeviceDialog from '@/views/product/product-details/firmware/taskList/components/specificDeviceDialog.vue'
import specificProjectDeviceList
from "@/views/product/product-details/firmware/taskList/components/specificProjectDeviceList.vue"
import conflictDetailsDialog
from "@/views/product/product-details/firmware/taskList/components/conflictDetailsDialog.vue"

// 提交时怎么处理冲突设备：
// replace = 覆盖旧任务（冲突设备写入新字段 replaceTaskDidList）
// exclude = 不覆盖，从本次 deviceIdList 里剔除这些设备
const CONFLICT_SUBMIT_ACTIONS = {
  REPLACE: 'replace',
  EXCLUDE: 'exclude'
}

// 后端保证一次返回的 flag 都一样。flag 4 以后只在这里补处理方式。
const CONFLICT_FLAG_SUBMIT_MAP = {
  1: CONFLICT_SUBMIT_ACTIONS.REPLACE, // 有未完成任务，且旧版本更低 → 覆盖
  2: CONFLICT_SUBMIT_ACTIONS.EXCLUDE, // 未完成任务版本更高 → 剔除
  3: CONFLICT_SUBMIT_ACTIONS.EXCLUDE // 设备正在升级 → 剔除
  // 4: CONFLICT_SUBMIT_ACTIONS.EXCLUDE
}

export default {
  name: "testDetails",
  components: {
    specificDeviceDialog,
    specificProjectDeviceList,
    conflictDetailsDialog
  },
  data() {
    const validateDeviceUuidList = (rule, value, callback) => {
      const deviceIdList = (value || '').trim()
      if (this.form.upgradeRange === 1 && !deviceIdList) {
        callback(new Error('请输入设备ID'))
        return
      }
      if (this.form.upgradeRange === 3 && !deviceIdList) {
        callback(new Error('所选项目下暂无设备'))
        return
      }

      const deviceList = deviceIdList.split(/[;；\s]+/).filter(Boolean)
      if (this.form.upgradeRange === 1 && deviceList.length > 32) {
        callback(new Error('输入设备id最多不超过32个'))
        return
      }
      callback()
    }
    const validateLabelsList = (rule, value, callback) => {
      if (this.form.upgradeRange === 2 && this.deviceTagId === '') {
        callback(new Error('请选择标签'))
      } else {
        callback()
      }
    }
    return {
      tableData: [], // 表格数据
      dialogVisible: false,
      form: {
        name: "", //升级任务名称
        otaMode: 'UOTA', //升级方案 (升级模式：UOTA-用户升级、SOTA-静默升级)
        upgradeFirmwareId: '', //当前升级固件id
        upgradeVersion: '', //当前升级固件版本
        upgradeableFirmwareIdList: '', //可升级版本id列表
        taskExpireTime: null, // 任务有效截止时间(升级方案(模式)为静默升级的时候才需要，默认1天)
        upgradeableVersionList: '', //可升级版本列表
        upgradeRange: '', //升级类型 (0:全部设备，1:特定设备)
        deviceIdList: '', //设备Uid列表
        deviceTagId: '' // 设备标签选中值
      },
      rules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { min: 2, max: 32, message: '请输入规范的任务名称', trigger: 'blur' },
          { validator: this.validateName, trigger: 'blur' }
        ],
        otaMode: [{ required: true, message: '请选择升级方案', trigger: 'blur' }],
        taskExpireTime: [{ required: true, message: "请选择任务有效截止时间", trigger: "blur" }],
        upgradeableVersionList: [{ required: true, message: "请选择可升级版本号", trigger: "blur" }],
        upgradeRange: [{ required: true, message: "请选择升级范围", trigger: "change" }],
        deviceIdList: { validator: validateDeviceUuidList, trigger: 'blur' },
        deviceTagId: [
          { required: true, message: '请选择标签', trigger: 'change' },
          {},
          { validator: validateLabelsList, trigger: 'change' }
        ]
      },
      uploadLoading: '', //新建升级任务弹窗的loading
      firmwareId: '', //当前固件firmwareId
      id: '', //当前固件id
      current: 1, //当前页面
      size: 10, //一页展示多少条
      total: 0, //总条数
      stateList: [
        //状态
        { value: 0, label: "执行中" },
        { value: 1, label: "执行完成" },
        { value: 2, label: "终止" }
      ],
      otaModeOptions: [ // 升级方案（升级模式）
        { value: 'UOTA', label: '用户升级' },
        { value: 'SOTA', label: '静默升级' }
      ],
      taskExpireTimeOptions: [ // 任务有效截止时间（任务过期时间）
        { value: 1, label: '1天' },
        { value: 2, label: '2天' },
        { value: 3, label: '3天' },
        { value: 4, label: '4天' },
        { value: 5, label: '5天' },
        { value: 6, label: '6天' },
        { value: 7, label: '7天' }
      ],
      // specificDeviceDetailsShowControl: false, // 特定设备: 对输入结果的查询弹窗，可以操作弹窗中的结果，弹窗控制显示/隐藏
      specificProjectDetailsShowControl: false, // 特定项目:显示选择的结果，以及选择项目下的设备的弹窗的，弹窗控制显示/隐藏
      version: '', //当前版本号
      productId: "", //当前产品id
      drawer: false, //升级任务详情弹窗
      direction: 'rtl', //升级任务详情弹窗方向
      taskInfo: '', //升级任务详情弹窗展示信息
      taskId: '', //当前详情的升级任务id
      taskLoading: false, //升级任务详情弹窗loading
      upgradeableFirmwareIdOptions: [], // 可升级版本list
      conflictDeviceList: [], // 升级任务冲突设备列表
      specificDeviceConfirmed: false, // 特定设备已点确定，并完成弹窗保存/二次确认
      suppressSpecificDeviceInputReset: false
      // labelsList: [] // 特定标签列表
    }
  },
  computed: {
    ...mapGetters(['rolesCode']),
    dynamicLink() {
      return `#/product/product-details/taskExecutionRecord?taskId=${this.taskId}`
    },
    getOtaName() {
      return val => {
        const exp = this.otaModeOptions.find(ota => ota.value === val)?.label
        return exp ? `${exp}` : '-'
      }
    },
    // 特定设备必须先点确定并完成弹窗确认，才能保存
    canSaveUpgradeTask() {
      if (this.form.upgradeRange === 1) {
        return this.specificDeviceConfirmed
      }
      return true
    }
  },
  created() { },
  mounted() {
    this.productId = this.$route.query.productId
    this.firmwareId = this.$route.query.firmwareId
    this.id = this.$route.query.id
    this.version = this.$route.query.version
    this.form.upgradeFirmwareId = this.$route.query.firmwareId //当前固件id
    this.form.upgradeVersion = this.$route.query.version //当前升级固件版本
    this.getUpgradeVersionListFun()
    this.getUpgradeTaskListFun()
    // this.queryLabelsList()
  },
  methods: {
    // 任务名称校验
    validateName(rule, value, callback) {
      const flag = new RegExp(/^[\u4E00-\u9FA5A-Za-z0-9]+$/).test(value)
      if (!flag) {
        callback(new Error('请输入规范的任务名称'))
      } else {
        callback()
      }
    },
    // 升级任务详情
    handleDetails(row) {
      this.drawer = true
      this.taskLoading = true
      if (row.id) {
        this.taskId = row.id
      }
      const params = {
        taskId: row.id || this.taskId
      }
      getUpgradeTaskInfo(params).then((res) => {
        this.taskInfo = res.data.data
        this.taskInfo.state = this.statusFormatter(res.data.data)
        this.taskLoading = false
      }).catch((err) => {
        this.$message.error(err.message)
        this.taskLoading = false
      })
    },
    /**
     * 特定标签列表
     */
    // queryLabelsList(condition, tagName) {
    //   this.currentPage = condition === 'search' ? 1 : this.currentPage
    //   const params = {
    //     size: 9999,
    //     current: 1
    //   }
    //   getList(params).then(res => {
    //     this.labelsList = res.data.data.records
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   }).finally(() => {
    //   })
    // },


    // 特定设备的查询结果
    handleOpenResultForSpecificDevice() {
      this.$refs.specificDevice.open()
    },
    handleOpenSpecificProjectDetails() {

    },
    // 特定设备的结果：检查升级设备ID，更新form.deviceIdList
    updateDeviceIdList(deviceIdList) {
      this.suppressSpecificDeviceInputReset = true
      this.form.deviceIdList = deviceIdList
      if (this.form.upgradeRange === 1) {
        this.specificDeviceConfirmed = true
      }
      // 项目设备为异步加载，更新后主动重新校验以清除旧错误提示
      this.$nextTick(() => {
        this.suppressSpecificDeviceInputReset = false
        this.$refs.form && this.$refs.form.validateField('deviceIdList')
      })
    },
    // 改了设备ID后需要重新点确定
    onSpecificDeviceIdInput() {
      if (this.suppressSpecificDeviceInputReset) return
      this.specificDeviceConfirmed = false
    },
    // 切换升级范围时清空上一种范围遗留的设备ID
    handleUpgradeRangeChange() {
      this.form.deviceIdList = ""
      this.specificDeviceConfirmed = false
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate('deviceIdList')
      })
    },
    // 新建升级任务弹窗关闭
    handleClose() {
      this.dialogVisible = false
      this.specificDeviceConfirmed = false
      this.$refs['form'].resetFields()
      // 关闭弹窗的时候，清空版本号表格的勾选状态
      this.$nextTick(() => {
        this.$refs['versionTable'] && this.$refs['versionTable'].clearSelection()
      })
      this.form.upgradeableVersionList = ''
      this.form.upgradeableFirmwareIdList = ''
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.size = val
      this.getUpgradeTaskListFun()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.current = val
      this.submitForm('form')
      this.getUpgradeTaskListFun()
    },
    //状态格式化
    statusFormatter(val) {
      const label = this.stateList.find((option) => option.value === val.state).label || "-"
      return label
    },

    // 删除升级任务
    deleteUpgradeTaskFun(row) {
      const params = {
        taskId: row.id
      }
      this.$confirm('升级任务删除后不可恢复，请谨慎操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteUpgradeTask(params).then((res) => {
          this.getUpgradeTaskListFun()
        }).catch((err) => {
          this.$message.error(err.message)
        })
      })
    },
    // 终止测试任务
    terminateUpgradeTaskFun(row) {
      const params = {
        taskId: row.id
      }
      terminateUpgradeTask(params).then((res) => {
        this.getUpgradeTaskListFun()
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    // 获取升级任务可升级版本号
    getUpgradeVersionListFun() {
      const params = {
        firmwareId: this.firmwareId,
        productComponentRelationId: this.id
      }
      getUpgradeVersionList(params).then((res) => {
        this.upgradeableFirmwareIdOptions = Array.isArray(res.data.data) ? res.data.data : []
      }).catch((res) => {

      })
    },
    // 任务有效截止时间改变时触发
    handleOtaModeChange(val) {
      this.form.otaMode = val
      if (this.form.otaMode === 'SOTA') {
        this.form.taskExpireTime = 1 // 默认1天
      } else {
        this.form.taskExpireTime = null
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate('taskExpireTime')
        })
      }
    },
    // 点击保存，表单提交
    submitForm(formName) {
      if (this.form.upgradeRange === 1 && !this.specificDeviceConfirmed) {
        this.$message.warning('请先点击确定，完成特定设备校验')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkDeviceUpgradeConflict()
        } else {
          return false
        }
      })
    },
    // 先查冲突：没冲突直接建任务，有冲突弹窗确认后再建
    checkDeviceUpgradeConflict() {
      this.uploadLoading = true
      const params = this.buildConflictCheckParams()
      postDeviceUpgradeConflict(params).then((res) => {
        const responseData = res.data.data || []
        this.conflictDeviceList = Array.isArray(responseData) ? responseData : []

        if (!this.conflictDeviceList.length) {
          this.addTestTaskFun()
          return
        }

        this.uploadLoading = false
        this.setConflictDialogData(this.conflictDeviceList)
      }).catch((err) => {
        this.$message.error(err.message)
        this.uploadLoading = false
      })
    },
    // 冲突检测入参：目标版本、设备id数组
    buildConflictCheckParams() {
      return {
        upgradeVersion: this.form.upgradeVersion,
        deviceIds: this.parseDeviceIdList(this.form.deviceIdList)
      }
    },
    // 弹窗自己按 flag 展示文案，这里只把冲突列表传进去
    setConflictDialogData(conflictList) {
      this.$refs.conflictDetails.open(conflictList)
    },
    getConflictFlag(conflictList) {
      return Number(conflictList[0] && conflictList[0].flag)
    },
    // 冲突结果里的全部 deviceId
    getConflictDidList(conflictList) {
      return (conflictList || [])
        .map(item => item.deviceId)
        .filter(id => id !== undefined && id !== null && id !== '')
        .map(id => String(id))
    },
    // 表单里的设备id是 "id1;id2"，转成数组
    parseDeviceIdList(deviceIdList) {
      return (deviceIdList || '').split(/[;；\s]+/).map(item => item.trim()).filter(Boolean)
    },
    stringifyUpgradeableVersionList() {
      return Array.isArray(this.form.upgradeableVersionList)
        ? this.form.upgradeableVersionList.join(';')
        : this.form.upgradeableVersionList
    },
    buildUpgradeTaskParams(extraParams = {}) {
      return {
        ...this.form,
        // 静默升级传有效截止天数；用户升级不传有效期
        taskExpireTime: this.form.otaMode === 'SOTA' ? this.form.taskExpireTime : null,
        upgradeableVersionList: this.stringifyUpgradeableVersionList(),
        productComponentRelationId: this.id,
        ...extraParams
      }
    },
    // 冲突弹窗点确认后，按 flag 改新建任务入参
    onConfirm() {
      this.$refs.conflictDetails.innerVisible = false
      this.addTestTaskFun(this.getConflictSubmitParams())
    },
    // flag 1：原 deviceIdList 照传，冲突设备写入 replaceTaskDidList
    // flag 2/3：replaceTaskDidList 传空数组，从 deviceIdList 去掉冲突设备
    getConflictSubmitParams() {
      const flag = this.getConflictFlag(this.conflictDeviceList)
      const action = CONFLICT_FLAG_SUBMIT_MAP[flag]
      const conflictDidList = this.getConflictDidList(this.conflictDeviceList)

      if (action === CONFLICT_SUBMIT_ACTIONS.REPLACE) {
        return {
          deviceIdList: this.form.deviceIdList,
          replaceTaskDidList: conflictDidList
        }
      }

      if (action === CONFLICT_SUBMIT_ACTIONS.EXCLUDE) {
        return this.getExcludeConflictDeviceParams(conflictDidList)
      }

      return {}
    },
    // 从本次任务设备里去掉冲突设备，replaceTaskDidList 传空
    getExcludeConflictDeviceParams(conflictDidList) {
      const conflictDidSet = new Set(conflictDidList)
      const deviceIdList = this.parseDeviceIdList(this.form.deviceIdList)
        .filter(did => !conflictDidSet.has(String(did)))
        .join(';')

      return {
        deviceIdList,
        replaceTaskDidList: []
      }
    },
    // 新建升级任务
    addTestTaskFun(extraParams = {}) {
      this.uploadLoading = true
      const params = this.buildUpgradeTaskParams(extraParams)
      return addUpgradeTask(params).then((res) => {
        this.$message.success('新建成功')
        this.handleClose()
        this.getUpgradeTaskListFun()
        this.dialogVisible = false
        this.$refs['form'].resetFields()
        this.uploadLoading = false
      }).catch((err) => {
        this.$message.error(err.message)
        this.uploadLoading = false
      })
    },
    // 获取升级任务列表
    getUpgradeTaskListFun() {
      const params = {
        size: this.size,
        current: this.current,
        firmwareId: this.firmwareId,
        productComponentRelationId: this.id
      }
      getUpgradeTaskList(params).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    // // 获取升级固件id
    // downgradeVersionChange(list) {
    //   var main = this
    //   var concatenatedIds = list.map(version => {
    //     var foundItem = main.upgradeableFirmwareIdOptions.find(item => {
    //       return item.version === version
    //     })
    //     return foundItem ? foundItem?.id : null
    //   }).filter(id => {
    //     return id !== null
    //   }).join(';')
    //   this.form.upgradeableFirmwareIdList = concatenatedIds
    // }
    //// 全选/多选 升级版本号
    handleSelectionChange(val) {
      this.form.upgradeableVersionList = val.map(item => item.version)
      this.form.upgradeableFirmwareIdList = val.map(item => item.id).join(';')
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

::v-deep .el-textarea .el-input__count {
  background: transparent;
  right: 20px;
}

::v-deep .el-dialog__body {
  padding: 32px 48px 36px 38px;
}

::v-deep .el-form-item__label {
  color: #808080;
}

::v-deep .el-input-group__append {
  background-color: #ffffff;
  color: #808080;
}

::v-deep .el-button+.el-button {
  margin-left: 16px;
}

::v-deep .name-input .el-input__inner {
  padding-left: 15px;
  padding-right: 48px;
  background: transparent;
}

::v-deep .el-table__fixed-right-patch {
  background-color: #F5F6F7;
}

.title {
  font-weight: 600;
  font-size: 14px;
}

.header {
  margin-top: 32px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-drawer__header {
  padding: 17px 0px 17px 20px;
  border: 1px solid #E5E6E9;
  font-weight: 600;
  color: #252525;
  font-size: 16px;
  margin-bottom: 0px;
}

.taskInfo {
  margin: 32px 0 0 74px;

  &:nth-child(2) {
    margin-top: 40px;
  }

  .InfoTitle {
    font-weight: 600;
    font-size: 14px;
  }

  .martop-16 {
    margin-top: 16px;
  }


  .refresh {
    padding: 7px 8px 6px;
    float: right;
    margin-right: 20px;
  }
}

.left {
  color: #808080;
  font-size: 14px;
  display: inline-block;
  width: 133px;
}

.right {
  color: #252525;
  font-size: 14px;
}

.status {
  float: right;
  padding: 3px 8px;
  background: rgba(12, 163, 209, 0.15);
  border-radius: 18px 18px 18px 18px;
  display: flex;
  align-items: center;
  font-weight: 400;
  color: #0CA3D1;
  font-size: 14px;
  margin-left: 33px;

  .status-icon {
    width: 6px;
    height: 6px;
    background: #0CA3D1;
    border-radius: 6px;
    margin-right: 6px;
  }
}

.width-60 {
  width: 60px;
  margin-left: 25px;
}

::v-deep .upgrade-task-dialog .el-dialog__body {
  padding: 20px 60px 20px 40px !important;
}
.button-container__right {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

// 外层 deviceIdList 校验失败时，只显示错误文案，
// 不把特定项目组件中的项目选择框和分页器输入框标红。
::v-deep .project-device-form-item.is-error {
  .specific-project-device-list {
    .el-input__inner {
      border-color: #DCDFE6;
    }

    .el-input__inner:hover {
      border-color: #C0C4CC;
    }

    .el-input__inner:focus {
      border-color: #409EFF;
    }
  }
}
</style>
